// extracted by mini-css-extract-plugin
export default {"wrap":"Center_wrap__b3XX3","inner":"Center_inner__18rL9"};